import React from "react";
import AccordionReferralCard from "components/card/AccordionReferralCard";
import FileRow from "components/file-components/file-row";
import { UserCard } from "components/card/UserCard";
import { EntityType, Owner, Referral } from "types";
import ReadMoreText from "components/ReadMoreText";

interface OwnerCardProps {
  referralData?: Referral | null;
  referralId?: string;
  handleButtonClick: (type: EntityType) => void;
  handleEdit: (type: EntityType, owner: Owner) => void;
  handleDelete: (id: string, type: EntityType) => void;
  handleUserView: (
    user: any,
    title: string,
    description: string,
    children?: React.ReactNode
  ) => void;
  fileRowProps: any;
}

export default function OwnerCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  handleDelete,
  handleUserView,
  fileRowProps,
}: OwnerCardProps) {
  return (
    <AccordionReferralCard
      title={`Owners - ${referralData?.owners?.length || 0}`}
      buttonText="Add Owner"
      onButtonClick={() => handleButtonClick("owner")}
      disabled={
        !referralData ||
        [
          "Asset Recovery Requested",
          "Asset Recovery Request Approved",
          "Asset Recovery On Revision",
          "Asset Recovery Updated",
          "Asset Recovery On Litigation",
          "Asset Recovery Final Verdict",
          "Prohibition On litigation",
          "Prohibition Final Verdict",
        ].includes(referralData?.action_status as string)
      }
    >
      {referralData?.owners && referralData.owners.length > 0 ? (
        <div className="space-y-4 p-4">
          {referralData.owners.map((owner) => (
            <UserCard
              key={owner.id}
              avatarUrl=""
              date={""}
              name={owner?.person?.full_name as string}
              role={owner?.person?.region as string}
              time={""}
              onDelete={() => handleDelete(owner?.id as string, "owner")}
              onEdit={() => handleEdit("owner", owner)}
              user={owner.person}
              title="Owner Details"
              description="Detailed information about owner"
              disabled={
                ![
                  "Investigation Ongoing",
                  "Pending",
                  "Prohibition On Revision",
                ].includes(referralData?.action_status as string)
              }
              onView={() =>
                handleUserView(
                  owner?.person,
                  "Owner Details",
                  "Detailed information about owner",
                  <div className="space-y-3">
                    <div className="flex flex-col items-start">
                      <h4 className="font-semibold text-gray-700">
                        Property Description
                      </h4>

                      {owner.property_description ? (
                        <p className="text-gray-700 whitespace-pre-wrap leading-relaxed  mb-4 text-left">
                          <ReadMoreText
                            text={owner.property_description}
                            maxLines={3}
                            fontSize="14px"

                          />
                        </p>
                      ) : (
                        <p className="text-gray-400">No summary provided</p>
                      )}
                    </div>

                    {owner.ownership_proof_details &&
                      owner.ownership_proof_details.length > 0 && (
                        <div>
                          <h4 className="font-semibold text-gray-700 mb-2">
                            Ownership Proof Documents:
                          </h4>
                          <div className="space-y-2">
                            {owner.ownership_proof_details.map(
                              (file: any, index: number) => (
                                <FileRow
                                  key={file.document_uuid || index}
                                  file={file}
                                  {...fileRowProps}
                                />
                              )
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                )
              }
            />
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">No owners added yet</div>
      )}
    </AccordionReferralCard>
  );
}
